export type AudioPropsType = {
  src: string;
  caption?: string;
  noDownload?: boolean;
};

function Audio({ src, caption, noDownload = false }: AudioPropsType) {
  return (
    <figure className='flex flex-col items-center justify-center gap-2'>
      {caption && <figcaption className='whitespace-nowrap font-medium'>{caption}</figcaption>}
      <audio
        preload='metadata'
        controls
        src={src}
        {...(noDownload ? { controlsList: 'nodownload' } : {})}
        className='w-full px-2'
      >
        Your browser does not support the
        <code>audio</code> element.
      </audio>
    </figure>
  );
}

export default Audio;
